<template>
  <div class="flex items-center gap-1 shrink-0">
    <button
      type="button"
      class="p-1.5 rounded hover:bg-white/5 text-text-muted hover:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      :title="$t('chat.call.start_audio')"
      :aria-label="$t('chat.call.start_audio')"
      :disabled="disabled"
      @click="onStart('audio')"
    >
      <el-icon size="14"><Phone /></el-icon>
    </button>
    <button
      type="button"
      class="p-1.5 rounded hover:bg-white/5 text-text-muted hover:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      :title="$t('chat.call.start_video')"
      :aria-label="$t('chat.call.start_video')"
      :disabled="disabled"
      @click="onStart('video')"
    >
      <el-icon size="14"><VideoCamera /></el-icon>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Phone, VideoCamera } from '@element-plus/icons-vue'
import { useCall } from '~/composables/chat/useCall'

/**
 * Compact call-trigger strip for the DM / group thread header.
 * Two buttons: audio-only and video. Disabled when the user is already
 * in a call (busy guard lives in useCall).
 */
const props = defineProps({
  threadId: { type: String, required: true },
  threadKind: { type: String, required: true } // 'dm' | 'group'
})

const emit = defineEmits(['error'])
const { isBusy, start } = useCall()

const disabled = computed(() => isBusy.value)

async function onStart(kind) {
  try {
    await start(props.threadId, props.threadKind, kind)
  } catch (err) {
    // Emit a stable code: DOMException.name (NotAllowedError, NotFoundError,
    // …) for media-permission failures, our own string codes for preflight /
    // mediasoup errors.
    const code = err?.name && err.name !== 'Error' ? err.name : (err?.message || 'call_start_failed')
    emit('error', code)
    // eslint-disable-next-line no-console
    console.error('[chat:call] start failed', err)
  }
}
</script>
